import React from 'react';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
} from 'recharts';
import { formatCurrency } from '../../utils/currency';

export type WeeklySpendPoint = {
  day: string;
  spent: number;
  orders?: number;
};

type Props = {
  data: WeeklySpendPoint[];
  height?: number;
};

const CustomTooltip: React.FC<any> = ({ active, payload, label }) => {
  if (!active || !payload || payload.length === 0) return null;
  const point = payload[0]?.payload as WeeklySpendPoint | undefined;
  const spent = Number(point?.spent || 0);
  const orders = Number(point?.orders || 0);

  return (
    <div
      style={{
        background: 'rgba(17, 24, 39, 0.95)',
        border: '1px solid rgba(255, 255, 255, 0.08)',
        borderRadius: 12,
        padding: '10px 12px',
        boxShadow: '0 12px 30px rgba(0, 0, 0, 0.35)',
        color: 'rgba(243, 244, 246, 0.95)',
        minWidth: 140,
        pointerEvents: 'none'
      }}
    >
      <div style={{ fontWeight: 700, marginBottom: 6 }}>{label}</div>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12 }}>
        <span style={{ color: 'rgba(209, 213, 219, 0.9)' }}>Spent</span>
        <span style={{ fontWeight: 700 }}>{formatCurrency(spent)}</span>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, marginTop: 4 }}>
        <span style={{ color: 'rgba(209, 213, 219, 0.9)' }}>Orders</span>
        <span style={{ fontWeight: 700 }}>{orders.toLocaleString()}</span>
      </div>
    </div>
  );
};

const WeeklySpendChart: React.FC<Props> = ({ data, height = 240 }) => {
  return (
    <div style={{ width: '100%', height }}>
      <ResponsiveContainer>
        <BarChart data={data} margin={{ top: 10, right: 16, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(148, 163, 184, 0.3)" />
          <XAxis
            dataKey="day"
            tickLine={false}
            axisLine={false}
            tick={{ fill: 'rgba(148, 163, 184, 0.95)', fontSize: 12 }}
          />
          <YAxis
            tickLine={false}
            axisLine={false}
            width={36}
            tick={{ fill: 'rgba(148, 163, 184, 0.95)', fontSize: 12 }}
            tickFormatter={(v) => `${Math.round(v)}`}
          />
          <Tooltip
            cursor={{ fill: 'rgba(59, 130, 246, 0.12)' }}
            wrapperStyle={{ zIndex: 9999, outline: 'none' }}
            content={<CustomTooltip />}
            labelFormatter={(l) => `${l}`}
            allowEscapeViewBox={{ x: true, y: true }}
          />
          <Bar dataKey="spent" radius={[6, 6, 0, 0]} fill="#3b82f6" maxBarSize={28} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default WeeklySpendChart;
